<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
				<el-form-item :label="$t('course_index.cate')" prop="cate" data-name="分类">
					<el-cascader v-model="filterForm.cate" clearable class="w100" :props="props_" :options="cateOption"></el-cascader>
				</el-form-item>
				<el-form-item :label="$t('course_index.date')" prop="date" data-name="日期">
					<el-date-picker v-model="filterForm.date" clearable value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
				</el-form-item>
				<el-form-item :label="$t('course_index.year')" prop="date" data-name="年度">
					<el-input v-model="filterForm.year" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('course_index.session')" prop="session" data-name="学期">
					<el-select v-model="filterForm.session" clearable class="w100" :placeholder="$t('index.pleaseInput')">
						<el-option v-for="(item,index) in SESSION_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.week')" prop="week" data-name="星期">
					<el-select v-model="filterForm.week" clearable class="w100" :placeholder="$t('index.pleaseInput')">
						<el-option v-for="(item,index) in WEEK_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.teacher')" prop="teacher_id" data-name="老师">
					<el-select v-model="filterForm.teacher_id" clearable class="w100" :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in teacher" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.teacher_id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.theme')" prop="keyword" data-name="主题">
					<el-input v-model="filterForm.keyword" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item label="ID" prop="ID" data-name="id">
					<el-input v-model="filterForm.id" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('course_index.buy_course_num')"  prop="buy_course_num" data-name="报名人数">
					<el-input v-model="filterForm.buy_course_num" type="Number" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('course_index.class')" prop="have_private" data-name="是否显示私教课">
					<el-select v-model="filterForm.have_private" clearable class="w100" :placeholder="$t('index.select')">
						<el-option :label="lang=='cn'?'否':'No'" :value="0"></el-option>
						<el-option :label="lang=='cn'?'是':'Yes'" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="handleCurrentChange(1)">{{$t('index.search')}}</el-button>
					<el-button type="" size="mini" @click="reset(1)">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
			<div class="fr">
				<el-button type="primary" size="mini" @click="course_export">{{$t('index.export')}}</el-button>
			</div>
		</div>
		<el-descriptions class="margin-top" :column="3" size="small" border>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.max_people')}}</template>{{data_data.all_max_student_num}}</el-descriptions-item>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.student_num')}}</template>{{data_data.all_student_num}}</el-descriptions-item>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.baokelv')}}</template>{{data_data.all_baokelv}}</el-descriptions-item>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.coupon_price')}}</template>{{data_data.all_coupon_price}}</el-descriptions-item>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.score')}}</template>{{data_data.all_score}}</el-descriptions-item>
		    <el-descriptions-item>
		    	<template slot="label">{{$t('statistic_course.pay_price')}}</template>{{data_data.all_pay_price}}
		    </el-descriptions-item>
		    <el-descriptions-item>
		    	<template slot="label">{{$t('statistic_course.number_courses_5')}}</template>{{data_data.all_5_course_num}}
		    </el-descriptions-item>
		    <el-descriptions-item>
		    	<template slot="label">{{$t('statistic_course.use_5')}}</template>{{data_data.all_5_score}}
		    </el-descriptions-item>
		    <el-descriptions-item>
		    	<template slot="label">{{$t('statistic_course.paid_5')}}</template>{{data_data.all_5_pay_price}}
		    </el-descriptions-item>
		    <el-descriptions-item>
		    	<template slot="label">{{$t('statistic_course.total_5')}}</template>{{(parseFloat(data_data.all_5_score)+parseFloat(data_data.all_5_pay_price)).toFixed(2)}}
		    </el-descriptions-item>
		</el-descriptions>
		<p><br></p>
		<el-table :data="list" border size="mini" :default-sort = "{prop: 'id', order: 'descending'}" :show-summary="true" :summary-method="summary_method_f">
			<el-table-column type="index" align="center" width="50"></el-table-column>
			<el-table-column prop="id" align="center" sortable label="ID" data-name="id" width="80"></el-table-column>
			<el-table-column :prop="lang=='cn'?'theme_cn':'theme'" align="center" :label="$t('course_index.theme')" data-name="主题" width="400">
				<template slot-scope="scope"><a target="_blank" class="clo3" :href="API_URL+'#/course_info?id='+scope.row.id">{{lang=='cn'?scope.row.theme_cn:scope.row.theme}}</a></template>
			</el-table-column>
			<el-table-column prop="teacher_id" align="center" :label="$t('course_index.teacher')" data-name="老师">
				<template slot-scope="scope">{{scope.row.teacher_id | teacher_f(this_)}}</template>
			</el-table-column>
			<el-table-column prop="week" align="center" :label="$t('course_index.week')" data-name="星期">
				<template slot-scope="scope">{{getTime_week(scope.row.have_date_time)}}</template>
			</el-table-column>
			<el-table-column prop="session" align="center" :label="$t('course_index.session')" data-name="学期">
				<template slot-scope="scope">{{getTime_us(scope.row.start_date,'yyyy')}} {{scope.row.session | session_ff(this_)}}</template>
			</el-table-column>
			<el-table-column prop="price" align="center" :label="$t('course_index.price')" data-name="单价"></el-table-column>
			<el-table-column prop="max_people" align="center" sortable :label="$t('statistic_course.max_people')" data-name="报名上限"></el-table-column>
			<el-table-column prop="student_num" align="center" sortable :label="$t('statistic_course.student_num')" data-name="报名人数"></el-table-column>
			<el-table-column prop="baokelv" align="center" sortable :label="$t('statistic_course.baokelv')" data-name="报课率"></el-table-column>
			<el-table-column prop="this_course_coupon_price" sortable align="center" :label="$t('statistic_course.coupon_price')" data-name="优惠金额"></el-table-column>
			<el-table-column prop="this_course_score" sortable align="center" :label="$t('statistic_course.score')" data-name="使用积分"></el-table-column>
			<el-table-column prop="this_course_pay_price" sortable align="center" :label="$t('statistic_course.pay_price')" data-name="课程收入"></el-table-column>
		</el-table>
		<!-- <div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
		</div> -->
	</div>
</template>
<script>
export default {
	computed: {
		props_(){
			return{
				checkStrictly: true,
				value: 'id',
				label: this.lang=='cn'?'name_cn':'name',
			}
		},
	},
	data() {
		return {
			API_URL:process.env.API_URL,
			this_:this,
			list: [],
			filterForm: {
				age:'',
				teacher_id:'',
				session:'',
				center_id:'',
				week:'',
				keyword:'',
				id:'',
				buy_course_num:'',
				have_private:0,
				cate:[],
				date:[],
			},
			WEEK_ARR: [],
			SESSION_ARR: [],
			cateOption: [],
			learnCenter:[],
			teacher:[],
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			data_data:{},
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: 'WEEK_ARR,SESSION_ARR',
			}
			this_.$post(url, datas).then((res) => {
				this_.WEEK_ARR = res.WEEK_ARR;
				this_.SESSION_ARR = res.SESSION_ARR;
			})
			var url = "cateOption";
			var datas={
				type:'1',
			}
			this_.$post(url, datas).then((res) => {
				this_.cateOption=this_.xunhaun(res.show);
			})
			var url = "courseScreen";
			this_.$post(url, {}).then((res) => {
				this_.learnCenter=res.learnCenter;
				this_.teacher=res.teacher;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "CourseCountList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
				teacher_id: this_.filterForm.teacher_id,
				session: this_.filterForm.session,
				week: this_.filterForm.week,
				keyword: this_.filterForm.keyword,
				id: this_.filterForm.id,
				buy_course_num: this_.filterForm.buy_course_num,
				have_private: this_.filterForm.have_private,
			};
			if (this_.filterForm.cate&&this_.filterForm.cate.length>0) {
				datas['cate_id']=this_.filterForm.cate[0];
				datas['cate_node_id']=this_.filterForm.cate[1]||'';
				datas['cate_three_id']=this_.filterForm.cate[2]||'';
				datas['cate_four_id']=this_.filterForm.cate[3]||'';
			}
			if (this_.filterForm.date&&this_.filterForm.date.length>0) {
				datas['start_search_time']=Math.round(this_.filterForm.date[0]/1000);
				datas['end_search_time']=Math.round(this_.filterForm.date[1]/1000);
			}else if(this_.filterForm.year){
				var start_search_time = Math.round(new Date(this_.filterForm.year,0,1,0,0,0).getTime()/1000);
				var end_search_time = Math.round(new Date(this_.filterForm.year,11,31,23,59,59).getTime()/1000);
				datas['start_search_time']=start_search_time;
				datas['end_search_time']=end_search_time;
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.data_data=res;
				this_.pages.count = res.sum;
			})
		},
		// 重置
		reset(){
			this.filterForm={
				age:'',
				teacher_id:'',
				session:'',
				center_id:'',
				week:'',
				keyword:'',
				buy_course_num:'',
				id:'',
				cate:[],
				date:[],
			}
			this.handleCurrentChange(1);
		},
		summary_method_f(res){
			var this_=this;
	        const { columns, data } = res;
	        const sums = [];
	        columns.forEach(function(e, i) {
	        	const values = data.map(item => Number(item[e.property]));
	        	var property={
	        		'max_people':this_.data_data.all_max_student_num,
	        		'student_num':this_.data_data.all_student_num,
	        		'baokelv':this_.data_data.all_baokelv,
	        		'this_course_coupon_price':this_.data_data.all_coupon_price,
	        		'this_course_score':this_.data_data.all_score,
	        		'this_course_pay_price':this_.data_data.all_pay_price,
	        	};
	        	if (i==0) {
	        		sums[i]=this_.lang=='cn'?'合计':'Total';
	        	}else if(property[e.property]){
	        		sums[i]=property[e.property]
	        	}else{
	        		sums[i]='N/A';
	        	}
	        });
	        return sums
		},
		course_export(){
			var TokenId = sessionStorage.getItem('TokenId');
			var lang  = localStorage.getItem('lang')!='cn'?'us':'cn';
			var url =  process.env.API_ROOT+'courseCountExport?TokenId='+TokenId+'&language='+lang;
			var filterForm=this.filterForm;
			if (filterForm.teacher_id) {
				url+='&teacher_id='+filterForm.teacher_id;
			}
			if (filterForm.session) {
				url+='&session='+filterForm.session;
			}
			if (filterForm.week) {
				url+='&week='+filterForm.week;
			}
			if (filterForm.keyword) {
				url+='&keyword='+filterForm.keyword;
			}
			if (filterForm.id) {
				url+='&id='+filterForm.id;
			}
			if (filterForm.date&&filterForm.date.length) {
				url+='&start_search_time='+Math.round(filterForm.date[0]/1000)+'&end_search_time='+Math.round(filterForm.date[1]/1000);
			}
			if (filterForm.cate&&filterForm.cate.length) {
				if (filterForm.cate[0]) {
					url+='&cate_id='+filterForm.cate[0]
				}
				if (filterForm.cate[1]) {
					url+='&cate_node_id='+filterForm.cate[1]
				}
				if (filterForm.cate[2]) {
					url+='&cate_three_id='+filterForm.cate[2]
				}
				if (filterForm.cate[3]) {
					url+='&cate_four_id='+filterForm.cate[3]
				}
			}
			console.log(url)
			window.open(url);
		},


		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},

	},
	// 过滤器
	filters: {
		session_ff(v,this_){
			var list=this_.SESSION_ARR;
			var fanhuizhi="";
			list.forEach(function(e, i) {
				if (e.code==v) {
					fanhuizhi=this_.lang=="cn"?e.name_cn:e.name;
				}
			});
			return fanhuizhi
		},
		teacher_f(v,this_){
			var list=this_.teacher;
			var fanhuizhi="";
			list.forEach(function(e, i) {
				if (e.teacher_id==v) {
					fanhuizhi=this_.lang=="cn"?e.name_cn:e.name;
				}
			});
			return fanhuizhi
		},

	}
}
</script>
<style scoped>
</style>
<style>
.demo-table-expand .el-form-item__label{
	padding: 0;
}
.demo-table-expand .el-form--inline .el-form-item{
	margin-right: 20px;
}
.router_link{
	display: inline;
	color: #ff0000;
}
.data_data{
	margin-right: 20px;
}
.filter-panel{
	width: calc(100% - 70px);
	float: left;
}
.el-descriptions th{
	width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/statistic/course.vue